import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  NgZone, OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTable} from '@angular/material/table';
import {OrderListDataSource} from './order-list-datasource';
import {Order, UpdateOrderGQL} from '../../graphql/graphql';
import {OrdersService} from '../orders.service';
import {OrderStatusChangeGQL} from '../graphql/graphql';
import {NotificationService} from '../../shared/notification.service';
// import {OrderStatuses} from '../types/order-statuses';
import {FilterInterface} from '../../shared/filter-bar/filter-bar.component';
import {OrderTypeEnum} from '../../shared/types/order-types';
import {UnseenOrdersService} from '../unseen-orders.service';
import {RelayIdService} from '../../shared/relay-id.service';
import {CancelOrderDialogComponent} from './cancel-order-dialog/cancel-order-dialog.component';
import {first} from 'rxjs/operators';
import {
  CandidateEventType,
  CreateOrderGQL,
  EventEventType, GetFilterRegionGQL,
  GetPaginatedOrderForTableGQL,
  GetSpecificationsGQL, InputMaybe,
  OrderCandidateStatsGQL,
  OrderErrorType,
  OrderInput,
  OrderPriority,
  OrdersList2FieldsFragment,
  OrderStatus,
  OrderType, Scalars,
  SpecificationCreateGQL,
  SpecificationInput,
  SpecificationModelCreateMutationInput, SpecificationSalaryPeriodEnum,
  SubmitOrder2GQL,
  UploadOrderForSigningGQL
} from '../../../generated/graphql';
import {OrdersCommentsDialogComponent} from '../../order/orders-comments-dialog/orders-comments-dialog.component';
import {SelectPersonDialogComponent} from '../select-person-dialog/select-person-dialog.component';
import { OrderCandidateComponent } from './order-candidate/order-candidate.component';
import {OrderActionsLogService} from '../order-actions-log/order-actions-log.service';
import { OrderTrafficGeneration } from 'src/app/shared/types/order-traffic-generation';
import { FormControl, Validators } from '@angular/forms';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import {FiledDownloaderService} from '../../shared/filed-downloader.service';
import { UserprofileService } from '../../shared/userprofile.service';
import { MetricsPopupComponent, WarningMap } from './metrics-popup/metrics-popup.component';
import { ActionsLogDialogComponent } from '../order-actions-log/actions-log-dialog/actions-log-dialog.component';
import { Moment } from 'moment/moment';
import { Router } from '@angular/router';
import { WorkwearIssuedBy } from '../workwear-issued-by';
import { OrderCreateService } from '../../order/order-create/order-create.service';
import { MatCalendarCellClassFunction, MatDatepicker, MatDateRangePicker } from '@angular/material/datepicker';


export enum OrderListModes {
  standalone = 'STANDALONE',
  dashboard = 'DASHBOARD'
}

// export enum EventType {
//   toBeInterviewed = 'toBeInterviewed',
//   toBeInterviewedClient = 'toBeInterviewedClient',
//   toBeEmployed = 'toBeEmployed'
// }


@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class OrderListComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<OrdersList2FieldsFragment>;

  private $companyId: number;
  @Input() set companyId(value: string) {
    this.$companyId = this.relayIdService.parseId(value);
  }
  eventTypes = EventEventType;
  priorities = OrderPriority;
  dataSource: OrderListDataSource;
  orderTypes = OrderTypeEnum;
  orderListViewModes = OrderListModes;
  statuses = OrderStatus;
  orderStats = {};
  displayedColumns = ['id', 'orderType', 'trafficGeneration', 'positionTitle', 'company', 'periodFrom', 'hourRate', 'status', 'shortage', 'actions'];
  preselectedCountry: string;

  yearRange: { start: Moment, end: Moment } | null = null;
  pendingStart: Moment | null = null;
  hoveredYear: number | null = null;
  filtersCache = {};

  private removeHoverListenerFn: (() => void) | null = null;

  @ViewChild('picker') picker: MatDatepicker<Moment>;

  mode = OrderListModes.standalone;
  unseenMessages;
  unseenMessagesSectionActive = false;
  @Input() set viewMode(value: OrderListModes) {
    this.mode = value;
    if (this.mode === OrderListModes.dashboard ) {
      this.displayedColumns =  ['orderType', 'company', 'priority',  'specification', 'periodFrom' , 'hourRate',
        'stats', 'alert', 'comment', 'responsible', 'lastUpdated', 'status'];
    }
  }
  @Input() showSelectionStatusFilter = false;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */

  editFieldMap: any = {
    shortage: {},
    trafficGeneration: {}
  };

  showEditShortageIcon: any = {};
  shortageCtl: any = {};

  showEditTrafficGenerationIcon: any = {};
  trafficGenerationCtl: any = {};

  trafficGenerationOptions = OrderTrafficGeneration;
  trafficGenerationOptionsDisplayMap: any = {};

  constructor(
    private ordersGQL: GetPaginatedOrderForTableGQL,
    private orderStatusChangeGQL: OrderStatusChangeGQL,
    private orderSendGQL: SubmitOrder2GQL,
    private uploadOrderForSigningGQL: UploadOrderForSigningGQL,
    private ordersSevice: OrdersService,
    private notifications: NotificationService,
    private unseenOrdersService: UnseenOrdersService,
    private relayIdService: RelayIdService,
    private dialog: MatDialog,
    private updateOrderGQL: UpdateOrderGQL,
    private orderStatsGql: OrderCandidateStatsGQL,
    public orderActionLogService: OrderActionsLogService,
    private translate: TranslateService,
    private createOrderGQL: CreateOrderGQL,
    private router: Router,
    private orderCreateService: OrderCreateService,
    private getSpecificationsGQL: GetSpecificationsGQL,
    private createSpecGQL: SpecificationCreateGQL,
    private getFilterRegionGQL: GetFilterRegionGQL,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.dataSource = new OrderListDataSource(this.ordersGQL, this.companyId);
    this.unseenOrdersService.getSubject().subscribe(res => {
      this.unseenMessages = res.unseenAccepted + res.unseenRejected;
    });

    this.dataSource.orderIds.subscribe(
      ids => {
        if (ids && ids.length && this.displayedColumns.indexOf('stats') > -1) {
          this.orderStatsGql.watch({
            orderIds: ids,
            dateFrom: (new Date()).toISOString().substr(0, 10)
          }, {fetchPolicy: "cache-and-network"}).valueChanges.subscribe(
            newStats => {
              newStats.data.candidateOrderStats.forEach(
                item => {
                  this.orderStats[item.orderId] = item;
                }
              );
            }
          );
        }
      }
    );

    this.getFilterRegionGQL.fetch().subscribe(v => {
      this.preselectedCountry = v.data.userprofile.region.country.id;
    });

    this.trafficGenerationOptionsDisplayMap[this.trafficGenerationOptions.inactive] = 'ORDER.TRAFFIC_GENERATION_OPTIONS.DO_NOT_GENERATE_TRAFFIC';
    this.trafficGenerationOptionsDisplayMap[this.trafficGenerationOptions.activeNoMarketing] = 'ORDER.TRAFFIC_GENERATION_OPTIONS.OFFER_WITHOUT_MARKETING';
    this.trafficGenerationOptionsDisplayMap[this.trafficGenerationOptions.activeWithMarketing] = 'ORDER.TRAFFIC_GENERATION_OPTIONS.OFFER_AND_RUN_MARKETING_CAMPAIGNS';
    this.trafficGenerationOptionsDisplayMap[this.trafficGenerationOptions.marketingOnly] = 'ORDER.TRAFFIC_GENERATION_OPTIONS.MARKETING_ONLY';
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
  }

  onClosePeriodCalendar() {
    if (!this.yearRange && this.pendingStart) {
      this.yearRange = null;
      this.pendingStart = null;
      this.hoveredYear = null;

      if (this.filtersCache) {
        this.onFilterChanges(this.filtersCache);
      }
    }
  }

  clearSelection() {
    this.yearRange = null;
    this.pendingStart = null;
    this.hoveredYear = null;

    if (this.filtersCache) {
      this.onFilterChanges(this.filtersCache);
    }
  }

  onYearSelected(date: Moment, picker: MatDatepicker<Moment>) {
    const year = date.year();

    if (!this.pendingStart) {
      this.pendingStart = date;
      this.yearRange = null;
      this.keepInMultiYearView(picker);
    } else {
      let start = this.pendingStart;
      let end = date;

      if (end.isBefore(start)) {
        [start, end] = [end, start];
      }

      this.yearRange = {
        start: start.startOf('year'),
        end: end.endOf('year')
      };

      this.pendingStart = null;
      this.hoveredYear = null;
      picker.close();

      if (this.filtersCache) {
        this.onFilterChanges(this.filtersCache);
      }
    }
  }

  private keepInMultiYearView(picker: MatDatepicker<Moment>) {
    setTimeout(() => {
      const calendar = picker['_componentRef']?.instance._calendar;
      if (calendar) {
        calendar.currentView = 'multi-year';
        calendar.updateTodaysDate();
        this.attachHoverListener();
      }
    }, 0);
  }

  onPickerOpened() {
    this.disablePickerPeriodButton();
    this.attachHoverListener();
  }

  private attachHoverListener() {
    if (this.removeHoverListenerFn) {
      this.removeHoverListenerFn();
      this.removeHoverListenerFn = null;
    }

    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const calendarBody = document.querySelector('.year-range-picker-panel .mat-calendar-body');

        if (calendarBody) {
          const handler = (event: Event) => {
            const target = event.target as HTMLElement;
            const cell = target.closest('.mat-calendar-body-cell');

            if (cell) {
              const ariaLabel = cell.getAttribute('aria-label');
              if (ariaLabel) {
                const year = parseInt(ariaLabel, 10);
                if (!isNaN(year) && this.hoveredYear !== year) {
                  this.ngZone.run(() => {
                    this.hoveredYear = year;
                    this.cdr.markForCheck();
                    this.picker['_componentRef']?.instance._calendar.updateTodaysDate();
                  });
                }
              }
            }
          };

          calendarBody.addEventListener('mouseover', handler);

          this.removeHoverListenerFn = () => {
            calendarBody.removeEventListener('mouseover', handler);
          };
        }
      }, 50);
    });
  }

  disablePickerPeriodButton() {
    setTimeout(() => {
      const target = document.querySelector<HTMLElement>('.mat-calendar-period-button');
      if (target) {
        target.style.display = 'none';
      }
    }, 0);
  }

  ngOnDestroy() {
    if (this.removeHoverListenerFn) {
      this.removeHoverListenerFn();
    }
  }

  dateClass: MatCalendarCellClassFunction<Moment> = (date, view) => {
    if (view !== 'multi-year') {
      return '';
    }

    const year = date.year();
    let start: number | null = null;
    let end: number | null = null;

    if (this.yearRange) {
      start = this.yearRange.start.year();
      end = this.yearRange.end.year();
    } else if (this.pendingStart && this.hoveredYear) {
      start = this.pendingStart.year();
      end = this.hoveredYear;
      if (end < start) {
        const temp = start;
        start = end;
        end = temp;
      }
    } else if (this.pendingStart) {
      start = this.pendingStart.year();
      end = start;
    }

    if (start !== null && end !== null) {
      if (year === start && year === end) {
        return 'range-start range-end';
      }
      if (year === start) {
        return 'range-start';
      }
      if (year === end) {
        return 'range-end';
      }
      if (year > start && year < end) {
        return 'range-year';
      }
    }

    return '';
  }

  openInterviewDialog(order: Order, eventType, $event) {
    $event.stopPropagation();
    this.dialog.open(OrderCandidateComponent,
      {
        width: '900px',
        data: {
          orderId: order.id,
          eventType,
          country: order.company?.country?.isoCode
        }

      }
    );
  }

  openInterviewDialogForOrdersWithinLast7Days(order: Order, eventType, $event) {
    $event.stopPropagation();
    this.dialog.open(OrderCandidateComponent,
      {
        width: '900px',
        data: {
          orderId: order.id,
          eventType: 'offeredInLast7Days',
          hideFilters: true,
          filters: {
            dateRange: {
              dateFrom: moment().subtract(7, 'days'),
              dateTo: moment()
            }
          } as FilterInterface,
          country: order.company?.country?.isoCode
        }
      }
    );
  }

  downloadOrder(orderId, positionTitle) {
    this.ordersSevice.downloadContract(this.relayIdService.parseId(orderId)).subscribe(
      r => this.downloadPDF(r, `${positionTitle} - ${this.relayIdService.parseId(orderId)}`),
      err => {
        err.error.text().then(res => {
          this.notifications.notify(err.status == 400 && res ? res : this.translate.instant('COMMON.ERRORS.GENERAL'), 1);
        });
      }
    );
  }

  downloadPDF(data: any, fileName?: string) {
    const url = window.URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName ? `${fileName}.pdf` : 'order.pdf';
    link.click();
  }


  sendOrder(order: Order) {
    this.orderSendGQL.mutate({input: this.relayIdService.parseId(order.id)}).subscribe(
      resp => {
        if (resp.data.submitOrder.ok) {
          order.status = OrderStatus.Sent;
          this.notifications.notify('EMAIL_SENT');
        } else {
          this.notifications.notify(`Error: ${resp.data}`);
        }
      },
      err => this.notifications.notify(`Error: ${err}`)
    );
  }

  markOrderAsSent(order: Order) {
    this.orderStatusChangeGQL.mutate({id: this.parseOrderId(order.id), transition: 'send'}).subscribe(
      resp => {
        if (resp.data.changeOrderStatus.ok) {
          order.status = OrderStatus.Sent;
          this.notifications.notify('Updated successfully');

        } else {
          this.notifications.notify(`Error: ${resp.data}`);
        }
      }
    );
  }


  // onSendButtonClick(order: Order)




  confirmOrder(order: any) {
    this.orderStatusChangeGQL.mutate({id: this.parseOrderId(order.id), transition: 'confirm'}).subscribe(
      resp => {
        if (resp.data.changeOrderStatus.ok) {
          order.status = OrderStatus.Confirmed;
          this.notifications.notify('Updated successfully');

        } else {
          this.notifications.notify(`Error:f ${resp.data}`);
        }
      }
    );
  }

  restoreOrder(order) {
    this.orderStatusChangeGQL.mutate(
      {id: this.parseOrderId(order.id), transition: 'restore'},
      {refetchQueries: ['getPaginatedOrderForTable']}
    ).subscribe(
      resp => {
        if (resp.data.changeOrderStatus.ok) {
          // order.status = OrderStatus.New;
          this.notifications.notify('Užsakymas atstatytas');

        } else {
          this.notifications.notify(`Error: ${resp.data}`);
        }
      }
    );
  }

  onFilterChanges(event: FilterInterface) {
    this.filtersCache = event;

    const filters = {};
    if (event.search) { filters['search'] = event.search; }
    if (event.region) { filters['region'] = event.region.join(','); }
    if (event.orderType) { filters['orderType'] = event.orderType; }
    if (event.statuses) { filters['status'] = event.statuses.join(',')  ; }
    if (event.selectionStatuses) { filters['trafficGeneration'] = event.selectionStatuses.join(',')  ; }
    if (event.keyAccountManager) { filters['keyAccountManager'] = event.keyAccountManager; }
    if (event.covidPolicy) { filters['covidPolicy'] = event.covidPolicy; }
    if (event.country) { filters['country'] = event.country; }
    if (this.$companyId) { filters['companies'] = this.$companyId; }
    if (this.yearRange) {
      filters['periodDateFrom'] = this.yearRange.start.format('YYYY-MM-DD');
      filters['periodDateTo'] = this.yearRange.end.format('YYYY-MM-DD');
    }
    this.dataSource.filters.next(filters);
    this.paginator?.firstPage();
  }

  showConfirmedRejected() {
    if (!this.unseenMessagesSectionActive) {
      const filters = this.dataSource.filters.value;
      filters['status'] = `${OrderStatus.Confirmed},${OrderStatus.Rejected}`;
      filters.unseenProcessedOrders = true;

      this.dataSource.filters.next(filters);
      const sub = this.dataSource.loadingCompleteSubject.subscribe(res => {
        this.unseenMessagesSectionActive = true;
        this.unseenOrdersService.sendReviewedDate().subscribe(res2 => {
          this.unseenOrdersService.emitData();
          if (sub && sub?.unsubscribe) {
            sub?.unsubscribe?.();
          }
        });
      });
    } else {
      const filters = this.dataSource.filters.value;
      filters['status'] = `${OrderStatus.New}`;
      filters.unseenProcessedOrders = false;
      this.dataSource.filters.next(filters);
      const sub = this.dataSource.loadingCompleteSubject.subscribe(res => {
        this.unseenMessagesSectionActive = false;
        if (sub && sub?.unsubscribe) {
          sub?.unsubscribe?.();
        }
      });
    }
  }

  parseOrderId(id: string) {
    return atob(id).split(':')[1];
  }

  openNew(s: string) {
    window.open( 'orders/edit/' + this.parseOrderId(s) , '_blank');
  }

  completeOrder(order: Order) {
    this.makeOrderStatusTransition(order, 'complete', OrderStatus.Completed);
  }

  makeOrderFilled(order: Order) {
    this.makeOrderStatusTransition(order, 'fill', OrderStatus.Filled);
  }

  cancelOrder(order: Order) {
    const dialogRef = this.dialog.open(CancelOrderDialogComponent);
    dialogRef.afterClosed().pipe(first()).subscribe(
      resp => {

        if (resp === 'cancel') {
          this.makeOrderStatusTransition(order, 'cancel', OrderStatus.Cancelled);
        }
      }
    );
  }

  private makeOrderStatusTransition(order: Order, transition: string, expectedStatus: OrderStatus) {
    this.orderStatusChangeGQL.mutate({id: this.parseOrderId(order.id), transition}).subscribe(
      resp => {
        if (resp.data.changeOrderStatus.ok) {
          order.status = expectedStatus;
          this.notifications.notify('Updated successfully');
        }
        // } else {
        //   this.notifications.notify(`Error: ${resp.data}`);
        // }
      }
    );
  }

  convertToNew(order: Order) {
    this.makeOrderStatusTransition(order, 'convert_to_new', OrderStatus.New);
  }

  addComment(order: OrdersList2FieldsFragment) {
    const commentDialog = this.dialog.open(OrdersCommentsDialogComponent, {
      data: {
        orderId: order.id
      }
    });
    commentDialog.afterClosed().subscribe(
      value => {
        if (value && value.length ){
          order.ordercommentSet.edges = value;
          this.dataSource.data.next(this.dataSource.data.value);
        }

      }
    );
  }

  changeUserprofile(order, field) {
    const dialogRef = this.dialog.open(SelectPersonDialogComponent);
    const oid = atob(order.id).split(':')[1];
    dialogRef.afterClosed().subscribe(
      val => {
        this.updateOrderGQL.mutate({
          id: oid,
          order: {[field]: val}
        }, {refetchQueries: ['getPaginatedOrderForTable']}).subscribe(
          r => {
            order.recruiter = r.data.updateOrder.order.recruiter;
            this.dataSource.data.next(this.dataSource.data.value);
            // this.changeDetectionRef.markForCheck();
          }
        );
      }
    );
  }

  updateOrderPriority(order: any, priority: OrderPriority) {
    let newPriority = order.priority === OrderPriority.High ? OrderPriority.Normal : OrderPriority.High;
    if (order.priority === priority) {
      newPriority = OrderPriority.Normal;
    } else {
      newPriority = priority;
    }

    this.updateOrderGQL.mutate(
      { id: this.parseOrderId(order.id), order: { priority: newPriority.toLowerCase() } },
      {
        refetchQueries: ['getPaginatedOrderForTable']
      }
    ).subscribe(val => {
    });
  }

  toggleEditTrafficGeneration(order) {
    this.editFieldMap['trafficGeneration'][order.id] = true;
    this.trafficGenerationCtl[order.id] = new FormControl(order.trafficGeneration, Validators.required);
  }

  toggleEditShortage(order) {
    this.editFieldMap['shortage'][order.id] = true;
    this.shortageCtl[order.id] = new FormControl(order.shortage, Validators.required);
  }

  changeField(order, field: string, value: number) {
    this.editFieldMap[field][order.id] = false;
    const oid = atob(order.id).split(':')[1];
    if(value || value === 0) {
      this.updateOrderGQL.mutate({
        id: oid,
        order: {[field]: value}
      }, {refetchQueries: ['getPaginatedOrderForTable']}).subscribe(
        r => {
          order[field] = r.data.updateOrder.order[field];
          this.dataSource.data.next(this.dataSource.data.value);
          this.notifications.notify('Updated successfully');
        });
    }
  }

  getCompanyLabelsText(edges: any) {
    return edges.map(it => it.node?.title).join(', ');
  }

  uploadForSigning(order: Order) {
    this.uploadOrderForSigningGQL.mutate({id: order.id}, {refetchQueries: ['getPaginatedOrderForTable']}).subscribe(
      resp => {
        if (resp.data.initOrderSigning.ok) {
          order.status = resp.data.initOrderSigning.order.status;

          this.notifications.notify('UPLOADING_ORDER');

          setTimeout(() => {this.dataSource.refetch();}, 3000);
        } else {
          this.notifications.notify(`Error: ${resp.data}`);
        }
      },
      err => this.notifications.notify(`Error: ${err}`)
    );
  }

  getPresentedClientTooltip(id: any) {
    const stats = this.orderStats[id];
    if (stats) {
      return this.translate.instant('PRESENTED_CLIENT_TOOLTIP', {
        total: stats.presentedClient || 0,
        success: stats.presentedClientSuccess || 0,
        failed: stats.presentedClientFailed || 0
      });
    }
    return undefined;
  }

  makeOrderLost(order) {
    this.makeOrderStatusTransition(order, 'lose', OrderStatus.Lost);
  }

  getWarningMap(order: OrderType): WarningMap {
    return {
      conversions: (order.ordermetrics?.effortConversion || 0) < (order.region?.regionmetrics?.effortConversion || 0),
      offers: (order.ordermetrics?.totalCalls || 0) < (order.region?.regionthresholdsettings?.minOffersExpected || 0),
      lifetime: (order.ordermetrics?.lifetime || 0) < (order.region?.regionmetrics?.lifetime)
    };
  }

  isOrderMetricsWarning(order: OrderType): boolean {
    const warningMap = this.getWarningMap(order);
    return Object.keys(warningMap).filter(key => warningMap[key]).length > 0;
  }

  showOrderMetrics(event, order) {
    this.dialog.open(MetricsPopupComponent, {
      data: { order, warningMap: this.getWarningMap(order) }
    });
  }

  getOrderLastClientContacted(order) {
    return order.orderclientcontactedSet?.edges
      .map(edge => edge.node)
      .sort((a, b) => moment(b.date).diff(moment(a.date)))[0];
  }

  onLastUpdatedChange(date: Moment, order, orderIdx) {
    this.ordersSevice.createOrderClientContacted(order.id, date.format('YYYY-MM-DD')).subscribe(
      res => {

        order.orderclientcontactedSet.edges = [
          ...this.dataSource.data.value[orderIdx].orderclientcontactedSet.edges,
          { node: res.data.createOrderClientContacted.orderClientContacted }
        ];
        this.dataSource.data.next(this.dataSource.data.value);
      },
      err => { }
    );
  }

  copyOrder(order: OrderType) {
    let orderInput: OrderInput;
    this.getSpecificationsGQL.fetch({id: +order.specification.id}).subscribe(
      spec$ => {
        const spec = { ...spec$.data.specification };
        const specInput: SpecificationModelCreateMutationInput = {
          company: this.relayIdService.parseIdAsCompanyType(order.company.id),
          positionTitle: spec.positionTitle + '(copy)',
          name: spec.positionTitle + '(copy)',
          address: spec.address,
          ageFrom: spec.ageFrom,
          ageTo: spec.ageTo,
          //@ts-ignore
          certificates: this.relayIdService.decodeIdForType(spec.certificates.map(v => v.id), 'CertificateType'),
          experienceType: spec.experienceType,
          female: spec.female,
          intensity: spec.intensity,
          isSecurityPostPresent: spec.isSecurityPostPresent,
          isWorkplaceVisitAllowed: spec.isWorkplaceVisitAllowed,
          male: spec.male,
          //@ts-ignore
          mandatoryRequirements: this.relayIdService.decodeIdForType(spec.mandatoryRequirements.map(v => v.id), 'RequirementType'),
          minExperienceMonths: spec.minExperienceMonths,
          onboardingDuration: spec.onboardingDuration,
          //@ts-ignore
          optionalRequirements: this.relayIdService.decodeIdForType(spec.optionalRequirements.map(v => v.id), 'RequirementType'),
          //@ts-ignore
          personalProtectiveEquipmentBiuro: this.relayIdService.decodeIdForType(spec.personalProtectiveEquipmentBiuro.map(v => v.id), 'PersonalProtectiveEquipmentType'),
          //@ts-ignore
          personalProtectiveEquipmentClient: this.relayIdService.decodeIdForType(spec.personalProtectiveEquipmentClient.map(v => v.id), 'PersonalProtectiveEquipmentType'),
          ppeItems: spec?.ppeItems?.length ? [{customEquipment: spec.ppeItems[0]?.customEquipment, provider: spec.ppeItems[0].provider.toLowerCase()}] as any : [],
          scheduleText: spec.scheduleText,
          //@ts-ignore
          scheduleTypes: this.relayIdService.decodeIdForType(spec.scheduleTypes.map(v => v.id), 'ScheduleTypeType'),
          //@ts-ignore
          salary: {
            description: spec.salary.description,
            hourlyBruttoFrom: spec.salary.hourlyBruttoFrom,
            hourlyBruttoFromFilled: spec.salary.hourlyBruttoFromFilled,
            hourlyBruttoTo: spec.salary.hourlyBruttoTo,
            hourlyBruttoToFilled: spec.salary.hourlyBruttoToFilled,
            hourlyNettoFrom: spec.salary.hourlyNettoFrom,
            hourlyNettoFromFilled: spec.salary.hourlyNettoFromFilled,
            hourlyNettoTo: spec.salary.hourlyNettoTo,
            hourlyNettoToFilled: spec.salary.hourlyNettoToFilled,
            monthlyBruttoFrom: spec.salary.monthlyBruttoFrom,
            monthlyBruttoFromFilled: spec.salary.monthlyBruttoFromFilled,
            monthlyBruttoTo: spec.salary.monthlyBruttoTo,
            monthlyBruttoToFilled: spec.salary.monthlyBruttoToFilled,
            monthlyNettoFrom: spec.salary.monthlyNettoFrom,
            monthlyNettoFromFilled: spec.salary.monthlyNettoFromFilled,
            monthlyNettoTo: spec.salary.monthlyNettoTo,
            monthlyNettoToFilled: spec.salary.monthlyNettoToFilled,
            passDescriptionToTemplate: spec.salary.passDescriptionToTemplate,
            //@ts-ignore
            useInTemplate: spec.salary.useInTemplate
          },
          //@ts-ignore
          riskFactors: this.relayIdService.decodeIdForType(spec.riskFactors.map(v => v.id), 'RiskFactorType'),
          //@ts-ignore
          assignmentTags: spec.tagassignmentSet.map( t => {
            return { tagId: t.tag.id, comment: t.comment };
          }),
          isQualificationImprovementPossible: spec.isQualificationImprovementPossible,
          clientWashesClothes: spec.clientWashesClothes,
          isWorkplaceVideoAllowed: spec.isWorkplaceVideoAllowed,
          workFunctions: spec.workFunctions,
          canEmployUa: spec.canEmployUa,
          additionalRecruitementInformation: spec.additionalRecruitementInformation
        };
        this.createSpecGQL.mutate({ input: specInput }).subscribe(
          (resp) => {
            if (order) {
              this.orderCreateService.getOrder(btoa(`OrderMType:${this.parseOrderId(order.id)}`)).subscribe(res => {
                const orderTemp = res.data.orderModel;
                orderInput = {
                  //@ts-ignore
                  additionalClientContacts: orderTemp.additionalClientContacts.edges.map(contact => atob(contact.node.id).split(':')[1]),
                  cancellationPeriod: orderTemp.cancellationPeriod,
                  projectManager: orderTemp.projectManager?.id,
                  recruiter: orderTemp?.recruiter?.id,
                  biuroSignee: orderTemp.biuroSignee?.id,
                  //@ts-ignore
                  additionalRegions: this.relayIdService.decodeIdForType(orderTemp.additionalRegions.map(v => v.id), 'RegionType'),
                  compensationForRecruitment: orderTemp?.compensationForRecruitment,
                  contract: orderTemp.contract?.id,
                  region: orderTemp.region?.id,
                  shortage: orderTemp.shortage,
                  salaryInfo: orderTemp.salaryInfo,
                  company: this.relayIdService.parseId(orderTemp.company.id).toString(),
                  workwearIssuedBy: WorkwearIssuedBy.client,
                  clientContact: this.relayIdService.parseId(orderTemp.clientContact.id).toString(),
                  specification: resp.data.specificationCreate.specification.id,
                  orderType: orderTemp.orderType,
                  trafficGeneration: orderTemp.trafficGeneration,
                  canIncreaseSalary: orderTemp.canIncreaseSalary,
                  passCommentToOrder: orderTemp.passCommentToOrder,
                  canGetBonuses: orderTemp.canGetBonuses,
                  isLogoPublicAllowed: orderTemp.isLogoPublicAllowed,
                  isCompanyInternational: orderTemp.isCompanyInternational,
                  isCompanyModern: orderTemp.isCompanyModern,
                  opportunityToEmployDirectly: orderTemp.opportunityToEmployDirectly,
                  orderCanBeExtended: orderTemp.orderCanBeExtended,
                  orderCanBeExtendedComment: orderTemp.orderCanBeExtendedComment,
                  //@ts-ignore
                  language: orderTemp.language,
                  minVsdfPayment: orderTemp.minVsdfPayment,
                  otherInfo: orderTemp.otherInfo,
                  workTimeRegistrationSystem: orderTemp.workTimeRegistrationSystem,
                  orderNumber: orderTemp.orderNumber,
                  //@ts-ignore
                  subtype: orderTemp.subtype,
                  createdFromBlank: true,
                  //@ts-ignore
                  qualification: orderTemp.qualification,
                  displayPlannedTermForProvision: orderTemp.displayPlannedTermForProvision,
                  exportFreetextRequirements: orderTemp.exportFreetextRequirements,
                  indefiniteOrderInfo: orderTemp.indefiniteOrderInfo
                };
                this.createOrderGQL.mutate({ order: orderInput }).subscribe(r => {
                    this.openNew(r.data.createOrder.order.id);
                  }
                );
              });
            }
          }
        );
      }
    )
  }

  openChangeLogDialog(orderId, country) {
    this.dialog.open(ActionsLogDialogComponent, {
      data: { orderId, country },
      minWidth: '80vw'
    });
  }
}
